import { render, staticRenderFns } from "./roleMgr.vue?vue&type=template&id=9a62e81c"
import script from "./roleMgr.vue?vue&type=script&lang=js"
export * from "./roleMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports